import { render, staticRenderFns } from "./AnnualLeaveYearList.vue?vue&type=template&id=1623b370&scoped=true&"
import script from "./AnnualLeaveYearList.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveYearList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1623b370",
  null
  
)

export default component.exports